<template>
  <!-- 复制弹框子组件 -->
  <div>
    <el-dialog :visible.sync="copyDialogForm" width="50%" center class="dialogItem" :close-on-click-modal="false">
      <el-form :ref="formTableLIst" :model="formTableLIst" label-width="120px">
        <el-form-item label="客户姓名">
          <el-input v-model.trim="formTableLIst.customerName" style="width: 90%" clearable> </el-input>
        </el-form-item>
        <el-form-item label="卡号" prop="cadCode">
          <el-input @input="testSX" v-model.trim="formTableLIst.cadCode" style="width: 90%"
            onkeyup="this.value=this.value.replace(/[^\d.]/g,'');" clearable> </el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="mobile">
          <el-input @input="testSX" v-model.trim="formTableLIst.mobile" style="width:80%"
            onkeyup="this.value=this.value.replace(/[^\d.]/g,'');" clearable> </el-input>
          <el-button class="info" type="primary" @click="getInfo" size="mini">获取信息</el-button>
        </el-form-item>
        <el-form-item label="预约门诊时间">
          <el-date-picker format="yyyy-MM-dd HH:mm" value-format="yyyy-MM-dd HH:mm:ss"
            v-model="formTableLIst.appointmentTime" type="datetime" placeholder="选择日期时间" style="width: 90%"
            :picker-options="disabledDate" @change="pickDateChange" @focus="pickDateFocus">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="项目类型">
          <el-select v-model="formTableLIst.projectType" placeholder="请选择项目类型" style="width:90%" @change="editTypeChange">
            <el-option v-for="item in projectTypeOptions" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <div class="formIndex">
          <el-form-item label="院区/楼层">
            <el-select @change="areaChange" v-model="formTableLIst.areaCode" placeholder="请选择院区" :disabled="areaDisabled"
              style="width: 45%">
              <el-option v-for="(item, index) in areaOptions" :key="index" :label="item.areaName" :value="item.areaCode">
              </el-option>
            </el-select>
            <el-select v-model="formTableLIst.floorCode" :disabled="floorDisabled" placeholder="请选择楼层" style="width: 45%"
              @change="floorChangeCopy">
              <el-option v-for="(item, index) in floorOptions" :key="index" :label="item.floorName"
                :value="item.floorCode">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="预约项目" prop="projectName">
            <el-select v-model="formTableLIst.projectId" @change="projectChangeEdit" @focus="projectFocus"
              :remote-method="(query) => { projectMethod(query, formTableLIst.projectType) }" filterable remote clearable
              placeholder="请输入搜索预约项目" style="width: 90%">
              <el-option v-for="item in projectOptions" :key="item.id" :label="item.projectName" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="宏脉项目名称" prop="hmProjectName">
            <el-input style="width: 90%" v-model="formTableLIst.hmProjectName" disabled></el-input>
          </el-form-item>
          <el-form-item label="仪器" prop="instrumentName" class="instrumentName">
            <el-select v-model="formTableLIst.instrumentId" placeholder="请选择" @input="testSX" @change="instrumentChange1"
              style="width: 90%">
              <el-option v-for="(item, index) in projectInstrument" :key="index" :label="item.instrumentName"
                :value="item.instrumentId">
              </el-option>
            </el-select>
          </el-form-item>
          <div class="appointTime" v-if="showTime">
            <el-select :class="value == '1' ? 'tips' : 'tooltips'" v-model="value">
              <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
            <div>
              <div class="appointTimeLong" v-if="value == '0'">
                <span v-for="(list, index) in successAppointTime.occupied" :key="index">
                  <el-tag type="danger">{{ list.instrumentDate }}</el-tag>
                </span>
              </div>
              <div class="appointTimeLong" v-if="value == '1'">
                <span v-for="(list, index) in successAppointTime.unoccupied" :key="index">
                  <el-tag>{{ list.instrumentDate }}</el-tag>
                </span>
              </div>
            </div>
          </div>

          <div v-for="(domain, idx) in editEppointmentPosition " :key="idx">
            <div class="instrucPosition">
              <el-form-item :label="'部位' + (idx + 1)">
                <el-select v-model="domain.positionId" @change="editPositionChange($event, idx)"
                  @focus="editPositionFocus($event, idx)" clearable placeholder="请选择仪器使用部位" style="width:45%;"
                  @input="testSX">
                  <el-option v-for="(ite, index) in editPositionOptions" :key="index"
                    :label="ite.positionName + '~' + ite.useMinute + '分钟'" :value="ite.positionId"
                    :disabled="ite.disabled">
                  </el-option>
                </el-select>
                <el-time-select v-if="timeFlag" @input="testSX" @change="dateChange($event, idx)" v-model="domain.useTime"
                  :picker-options="{ start: '09:00', step: '00:05', end: '23:00' }" placeholder="选择仪器部位使用时间"
                  @focus="dateFocus"></el-time-select>
                <el-time-select v-if="dateFlag" @input="testSX" @change="dateChange($event, idx)" v-model="domain.useTime"
                  :picker-options="{ start: '08:00', step: '01:00', end: '23:00' }" placeholder="选择仪器部位使用时间"
                  @focus="dateFocus"></el-time-select>
                <el-button size="mini" type="danger" @click.prevent="editRemoveDomain(domain, idx)" v-show="idx > 0">
                  <i class="el-icon-delete"></i>
                </el-button>
              </el-form-item>
            </div>
          </div>
          <el-form-item style="text-align: right;margin-right:5%;">
            <el-button @click="editAddDomain" type="primary" size="mini">新增部位</el-button>
          </el-form-item>
          <el-form-item label="操作人" prop="doctorName">
            <el-select v-model="formTableLIst.doctorId" placeholder="请选择" style="width: 90%" @change="docotrChange1"
              @focus="docotrFocusEdit">
              <el-option v-for="(item, index) in projectDoctor" :key="index" :label="item.doctorName"
                :value="item.doctorId">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="初诊/复诊" prop="appointStatus">
            <el-select v-model="formTableLIst.appointStatus" placeholder="请选择" style="width: 90%">
              <el-option v-for="option in typeOptions" :key="option.value" :label="option.text" :value="option.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="备注" prop="remark">
            <el-input style="width: 90%" v-model="formTableLIst.remark" type="textarea" autosize></el-input>
          </el-form-item>
        </div>
      </el-form>
      <div class="clearBottom">
        <div class="partFooter">
          <el-button type="danger" @click="copyDialogForm = false">取 消</el-button>
          <el-button type="primary" @click="copySure()">确 定</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: 'copyAppoint',
  props: ['formTableLIst', 'projectInfoList', 'appointmentList'],
  data() {
    return {
      typeOptions: [{
        text: '初诊',
        value: 0
      },
      {
        text: '复诊',
        value: 1
      },
      {
        text: 'VIP',
        value: 2
      },
      ],
      copyDialogForm: false,
      projectOptions: [],
      projectData: [],
      projectInstrument: [],
      projectDoctor: [],
      listName1: '',
      listName2: '',
      arrList3: [],
      arrList4: [],
      projectIdData: '',
      disabledDate: {
        disabledDate: (time) => {
          return time.getTime() < new Date().getTime() - 8.64e7
        },
      },
      disabledDateEdit: {},
      editShowTime: false,
      editSuccessAppointTime: '',
      projectDoctorList: [],
      rules: {
        mobile: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
        ],
      },
      editEppointmentPosition: [{
        positionId: '',
        useTime: '',
        positionName: '',
      }],
      showTime: false,
      successAppointTime: '',
      editPositionOptions: {},
      copyProjectName: '',
      offFirstEnter: false,
      instrumentNum: '',
      areaOptions: [{
        areaName: '伯思立',
        areaCode: 'bsl'
      }, {
        areaName: '翡立思',
        areaCode: 'fls'
      }, {
        areaName: '南通伯思立',
        areaCode: 'ntbsl'
      }],
      floorOptions: [{
        floorName: '2楼',
        floorCode: '2'
      }, {
        floorName: '3楼',
        floorCode: '3'
      },
      {
        floorName: '12楼',
        floorCode: '12'
      },
      ],
      focusTime: '',
      options: [{
        value: '0',
        label: '当日已预约时间'
      }, {
        value: '1',
        label: '当日可预约时间'
      }],
      value: '1',
      projectTypeOptions: [{
        value: '1',
        label: '皮肤'
      }, {
        value: '2',
        label: '注射'
      }, {
        value: '3',
        label: '其他'
      }],
      dateFlag: false,
      timeFlag: true,
      areaType: Lockr.get('areaType'),
      cityCode: Lockr.get('cityCode'),
      areaDisabled: true,
      floorDisabled: false,
    };
  },
  created() {
    if (!this.areaType || this.areaType == undefined) {
      this.areaDisabled = false
    }
    if (this.areaType == 'fls') {
      this.formTableLIst.floorCode = '1'
      this.floorDisabled = true
      this.floorOptions = [{
        floorName: '1楼',
        floorCode: '1'
      }]
    } else if (this.areaType == 'bsl') {
      this.floorDisabled = false
    } else if (this.areaType == 'ntbsl') {
      this.formTableLIst.floorCode = '1'
      this.floorDisabled = true
      this.floorOptions = [{
        floorName: '1楼',
        floorCode: '1'
      }]
    }
  },
  mounted() { },
  watch: {
    projectInfoList: function (newVal, oldVal) {
      console.log(newVal)
      this.dateFlag = false
      this.timeFlag = true
      this.showOrHide(newVal.projectName)
      this.projectInstrument = newVal.projectInstrument
      this.projectDoctor = newVal.projectDoctor
      this.projectDoctorList = newVal.projectDoctor
      this.value = '1'
    },
    appointmentList: {
      handler(newVal, oldVal) {
        this.editEppointmentPosition = newVal
        this.editEppointmentPosition.forEach(ele => {
          ele.useTime = ele.useTimeStart
        });
        if (!this.offFirstEnter) {
          return;
        }
        this.getFatherData()
      }
    },
    formTableLIst: {
      handler(newVal, oldVal) {
        console.log(newVal)
        if (newVal.areaCode == 'fls') {
          this.formTableLIst.floorCode = '1'
          this.floorDisabled = true
          this.floorOptions = [{
            floorName: '1楼',
            floorCode: '1'
          }]
        } else if (newVal.areaCode == 'bsl') {
          this.floorDisabled = false
          this.floorOptions = [{
            floorName: '2楼',
            floorCode: '2'
          }, {
            floorName: '3楼',
            floorCode: '3'
          },
          {
            floorName: '12楼',
            floorCode: '12'
          },]
        } else if (newVal.areaCode == 'ntbsl') {
          this.formTableLIst.floorCode = '1'
          this.floorDisabled = true
          this.floorOptions = [{
            floorName: '1楼',
            floorCode: '1'
          }]
        }
      }
    },
  },
  methods: {
    // 获取信息
    getInfo() {
      if (this.formTableLIst.cadCode == '' && this.formTableLIst.mobile == '') {
        _g.toast("warning", '请填写手机号或卡号');
        return;
      }
      // this.formTableLIst.customerName = ""
      Lockr.set("selected", 1)
      this.loading = true
      let data = {
        clientCard: this.formTableLIst.cadCode,
        clientMobile: this.formTableLIst.mobile,
        clientName: this.formTableLIst.customerName,
        pageIndex: 1,
      }
      api.requestQuiet("/register/getClientInformation", data, (res) => {
        console.log(res)
        if (res.result == true) {
          this.loading = false
          if (res.data.mapList.length == 1) {
            this.formData.mobile = res.data.mapList[0].clientMobile
            this.formData.cadCode = res.data.mapList[0].clientCard
            this.formData.customerName = res.data.mapList[0].clientName
            this.$forceUpdate()
          } else {
            let loadOptions = res.data.mapList
            this.$emit('editDialog', loadOptions)

          }
        } else {
          this.loading = false
          //   获取信息之后是否可以编辑信息
          this.disabled = false
          _g.toast("warning", '请手动添加客户信息');
        }
      }, (err) => {
        this.loading = false
      });
    },
    areaChange(val, index) {
      if (val == 'fls') {
        this.formTableLIst.floorCode = '1'
        this.floorOptions = [{
          floorName: '1楼',
          floorCode: '1'
        }]
        this.floorDisabled = true
      } else if (val == 'bsl') {
        this.floorDisabled = false
        this.formTableLIst.floorCode = ''
        this.floorOptions = [{
          floorName: '2楼',
          floorCode: '2'
        }, {
          floorName: '3楼',
          floorCode: '3'
        },
        {
          floorName: '12楼',
          floorCode: '12'
        },]
      } else if (val == 'ntbsl') {
        this.formTableLIst.floorCode = '1'
        this.floorOptions = [{
          floorName: '1楼',
          floorCode: '1'
        }]
        this.floorDisabled = true
      }
    },
    getFatherData() {
      // 部位回显
      api.request("/instrument/findInstrumentById", {
        instrumentId: this.formTableLIst.instrumentId
      }, (res) => {
        this.$nextTick(() => {
          this.editPositionOptions = res.data.InstrumentPosition
          this.editPositionOptions.map((x, i) => {
            this.editEppointmentPosition.map((s) => {
              if (x.positionId === s.positionId) {
                x.disabled = true
              }
            })
          })
          this.$forceUpdate()
        });
      }, (err) => { })
      // // 根据预约门诊时间和仪器id提示仪器已预约时间
      if (this.formTableLIst.instrumentId != '') {
        let queryData = {
          appointmentTime: this.formTableLIst.appointmentTime,
          instrumentId: this.formTableLIst.instrumentId,
        }
        api.request("/appointment/findInstrumentDateById", queryData, (res) => {
          if (res.result == true) {
            let dataTimeAppoint = res.data
            if (dataTimeAppoint.unoccupied) {
              this.showTime = true
              this.successAppointTime = dataTimeAppoint
            } else if (!dataTimeAppoint.unoccupied) {
              this.showTime = false
            }
          }
          this.$forceUpdate()
        }, (err) => { });
      }
      // 项目名称回显
      let querys = {
        projectName: "",
        projectType: this.formTableLIst.projectType,
        areaCode: this.formTableLIst.areaCode,
        cityCode: this.cityCode
      };
      api.request("/project/findProjectListByName", querys, (res) => {
        // console.log(res)
        if (res.data.length == 0) {
          _g.toast("warning", "还没有可选择的项目!");
        }
        this.projectOptions = res.data;
      }, (err) => { });
    },
    openDialog1Visible() {
      this.offFirstEnter = true
      this.copyDialogForm = true;
    },
    //  复制时项目类型发生改变清空值
    editTypeChange() {
      this.formTableLIst.areaCode = this.areaType
      this.formTableLIst.floorCode = ''
      this.formTableLIst.instrumentId = ''
      this.formTableLIst.instrumentName = ''
      this.formTableLIst.doctorId = ''
      this.formTableLIst.doctorName = ''
      this.formTableLIst.projectId = ''
      this.formTableLIst.projectName = ''
      this.formTableLIst.remark = ''
      this.formTableLIst.timeFlag = true
      this.formTableLIst.dateFlag = false
      this.formTableLIst.appointStatus = ''
      this.showTime = false
      this.editEppointmentPosition = [{
        positionId: '',
        useTime: '',
        positionName: '',
        positionNameTime: '',
      }]
      if (this.areaType == 'fls') {
        this.formTableLIst.floorCode = '1'
        this.floorDisabled = true
        this.floorOptions = [{
          floorName: '1楼',
          floorCode: '1'
        }]
      } else if (this.areaType == 'bsl') {
        this.floorDisabled = false
      } else if (this.areaType == 'ntbsl') {
        this.formTableLIst.floorCode = '1'
        this.floorDisabled = true
        this.floorOptions = [{
          floorName: '1楼',
          floorCode: '1'
        }]
      }
    },
    CompareDate(t1, t2) {
      var date = new Date();
      var a = t1.split(":");
      var b = t2.split(":");
      return date.setHours(a[0], a[1]) > date.setHours(b[0], b[1]);
    },
    pickDateChange(val) {
      var cc = val.split(' ')[1]
      var dd = '08:59:59'
      if (this.CompareDate(cc, dd) == false) {
        this.formTableLIst.appointmentTime = ''
        _g.toast("warning", "请选择九点之后的时间");
        return;
      }
      this.formTableLIst.doctorId = ''
      this.formTableLIst.doctorName = ''
      this.listName2 = ''
      this.arrList4 = ''
      let year1 = this.focusTime.split('-')[0]
      let year2 = val.split('-')[0]
      let month1 = this.focusTime.split('-')[1]
      let month2 = val.split('-')[1]
      if (this.focusTime != '') {
        var day1 = this.focusTime.split('-')[2].substring(0, 2)
      }
      let day2 = val.split('-')[2].substring(0, 2)
      if (year1 == year2 && month1 == month2 && day1 == day2) {
        console.log('同一天')
      } else {
        console.log('更改日期')
        // 修改预约门诊时间时直接修改预约仪器部位时间
        this.editEppointmentPosition.forEach((ele, idx) => {
          let aa = ele.useTime.split(' ')[1]
          let bb = val.split(' ')[0]
          ele.useTime = bb + ' ' + aa

          // // 根据预约门诊时间和仪器id提示仪器已预约时间
          if (this.formTableLIst.instrumentId != '') {
            let queryData = {
              appointmentTime: this.formTableLIst.appointmentTime,
              instrumentId: this.formTableLIst.instrumentId,
            }
            api.request("/appointment/findInstrumentDateById", queryData, (res) => {
              if (res.result == true) {
                let dataTimeAppoint = res.data
                if (dataTimeAppoint.unoccupied) {
                  this.showTime = true
                  this.successAppointTime = dataTimeAppoint
                } else if (!dataTimeAppoint.unoccupied) {
                  this.showTime = false
                }
              }
              this.$forceUpdate()
            }, (err) => { });
          }
        });
        this.$forceUpdate()
      }

    },
    pickDateFocus(val) {
      if (this.formTableLIst.appointmentTime) {
        this.focusTime = this.formTableLIst.appointmentTime
      }
    },
    // 搜索查询全部可预约项目
    projectMethod(val, projectType) {
      let querys = {
        projectName: val,
        projectType: projectType,
        areaCode: this.formTableLIst.areaCode,
        cityCode: this.cityCode
      };
      api.request("/project/findProjectListByName", querys, (res) => {
        // console.log(res)
        if (res.data.length == 0) {
          _g.toast("warning", "还没有可选择的项目!");
        }
        this.projectOptions = res.data;
      }, (err) => { });
    },
    // 编辑操作根据选中的项目id查询可用仪器操作人等
    projectChangeEdit(val) {
      console.log(val)
      this.projectOptions.forEach(ele => {
        if (val == ele.id) {
          this.copyProjectName = ele.projectName
        }
      });
      this.projectIdData = val
      let querys = {
        id: val,
        areaCode: this.formTableLIst.areaCode,
        floorCode: this.formTableLIst.floorCode,
        areaType: this.areaType
      };
      api.request("/project/findProjectBydId", querys, (res) => {
        this.projectData = res.data
        // 编辑时部位回显
        if (this.formTableLIst) {
          this.formTableLIst.positionName = this.projectData.positionName
          this.formTableLIst.positionId = this.projectData.positionId
          this.formTableLIst.hmProjectName = this.projectData.hmProjectName
          this.projectInstrument = this.projectData.projectInstrument
          this.projectDoctor = this.projectData.projectDoctor
          this.projectDoctorList = this.projectData.projectDoctor
          ele.hmProjectName = this.projectData.hmProjectName
          this.projectDoctorList.forEach(ele => {
            ele.doctorId = ele.doctorId.toString()
          });
        }
      }, (err) => { });
      this.showOrHide(this.copyProjectName)
    },
    // 仪器部位时间选择器切换
    showOrHide(projectName) {
      let ss = projectName.includes('热拉提')
      let vv = projectName.includes('热玛吉')
      if (ss == true || vv == true) {
        this.dateFlag = true
        this.timeFlag = false
      } else {
        this.dateFlag = false
        this.timeFlag = true
      }
    },
    // 编辑弹框查询项目
    projectFocus(val) {
      let querys = {
        projectName: "",
        projectType: this.formTableLIst.projectType,
        areaCode: this.formTableLIst.areaCode,
        cityCode: this.cityCode
      };
      api.request("/project/findProjectListByName", querys, (res) => {
        // console.log(res)
        if (res.data.length == 0) {
          _g.toast("warning", "还没有可选择的项目!");
        }
        this.projectOptions = res.data;
      }, (err) => { });
      this.formTableLIst.instrumentId = ''
      this.formTableLIst.instrumentName = ''
      this.formTableLIst.doctorId = ''
      this.formTableLIst.doctorName = ''
      this.editEppointmentPosition = [{
        positionId: '',
        useTime: '',
        positionName: '',

      }]
      this.showTime = false,
        this.successAppointTime = '',
        this.editShowTime = false
    },
    // 热拉提项目两小时时间制
    dateChange(val, index) {
      val = this.formTableLIst.appointmentTime.split(' ')[0] + ' ' + val + ':00'
      console.log(val)
      var oDate1 = new Date(this.formTableLIst.appointmentTime);
      var oDate2 = new Date(val);
      if (oDate1) {
        if (oDate1.getTime() > oDate2.getTime()) {
          _g.toast("warning", "预约仪器时间不得早于预约门诊时间");
          this.editEppointmentPosition[index].useTime = ''
          this.$forceUpdate()
          return; //第一个大
        }
      }
      this.editEppointmentPosition[index].useTime = val
      this.$forceUpdate()
    },
    floorChangeCopy() {
      this.formTableLIst.id = ''
      this.formTableLIst.instrumentId = ''
      this.formTableLIst.instrumentName = ''
      this.formTableLIst.doctorId = ''
      this.formTableLIst.doctorName = ''
      this.editEppointmentPosition = [{
        positionId: '',
        useTime: '',
        positionName: '',
      }]
      this.editShowTime = false
      this.showTime = false
      this.successAppointTime = ''
    },
    testSX() {
      console.log('强制刷新')
      this.$forceUpdate()
    },
    instrumentChange1(val) {
      this.arrList3 = val
      this.projectInstrument.forEach(item => {
        if (item.instrumentId == val) {
          this.listName1 = item.instrumentName
        }
      });
      this.editEppointmentPosition = [{
        positionId: '',
        useTime: '',
        positionName: '',
      }]
      this.showTime = false,
        this.successAppointTime = '',
        this.formTableLIst.doctorId = ''
      this.formTableLIst.doctorName = ''
      api.request("/instrument/findInstrumentById", {
        instrumentId: val
      }, (res) => {
        this.$nextTick(() => {
          this.editPositionOptions = res.data.InstrumentPosition
          this.editPositionOptions.map((x, i) => {
            this.editEppointmentPosition.map((s) => {
              if (x.positionId === s.positionId) {
                x.disabled = true
              }
            })
          })
          this.$forceUpdate()
        });
      }, (err) => { })
      // 根据预约门诊时间和仪器id提示仪器已预约时间
      if (this.formTableLIst.instrumentId != '') {
        let queryData = {
          appointmentTime: this.formTableLIst.appointmentTime,
          instrumentId: this.formTableLIst.instrumentId,
        }
        api.request("/appointment/findInstrumentDateById", queryData, (res) => {
          if (res.result == true) {
            let dataTimeAppoint = res.data
            if (dataTimeAppoint.unoccupied) {
              this.showTime = true
              this.successAppointTime = dataTimeAppoint
              console.log(this.editEppointmentPosition)
            } else if (!dataTimeAppoint.unoccupied) {
              console.log('kongde')
              this.showTime = false
            }
          }
          this.$forceUpdate()
        }, (err) => { });
      }
    },
    editFocusInstrument() {
      this.formTableLIst.doctorId = ''
      this.formTableLIst.doctorName = ''
      this.listName2 = ''
      this.arrList4 = ''
      this.disabledDateEdit = {
        disabledDate: (time) => {
          let disable = time.getTime() > new Date(this.formTableLIst.appointmentTime).getTime() ||
            time
              .getTime() <
            new Date(
              this.formTableLIst.appointmentTime).getTime() - 8.64e7
          return disable
        },
      }
    },
    dateFocus() {
      this.formTableLIst.doctorId = ''
      this.formTableLIst.doctorName = ''
      this.listName2 = ''
      this.arrList4 = ''
    },
    docotrChange1(val) {
      this.arrList4 = val
      this.projectDoctor.forEach(item => {
        if (item.doctorId == val) {
          this.listName2 = item.doctorName
        }
      });

    },
    // 编辑时筛选操作人
    docotrFocusEdit() {
      // 根据选择仪器时间筛选操作人
      let arrForm = []
      this.projectDoctorList.forEach(ele => {
        arrForm.push(ele.doctorId)
      });
      let queryData = {
        appointmentTime: this.formTableLIst.appointmentTime,
        doctorIds: arrForm,
        instrumentId: this.formTableLIst.instrumentId,
        appointmentPosition: this.editEppointmentPosition,
        choiceDoctorId: this.formTableLIst.doctorId
      }
      api.request("/appointment/findDoctorByInstrumentDate", queryData, (res) => {
        if (res.result == true) {
          let resData = res.data
          // 筛选id相同的医生数据
          if (resData.length != 0) {
            resData.forEach(ele => {
              ele.doctorId = ele.doctorId.toString()
            });
            let add = this.projectDoctorList.filter(item => resData.some(ele =>
              ele.doctorId === item.doctorId))
            add.push({
              doctorId: '999999',
              doctorName: '无指定操作人'
            })
            this.projectDoctor = add
            console.log(this.projectDoctor)
          } else if (resData.length == 0) {
            this.projectDoctor = [{
              doctorId: '999999',
              doctorName: '无指定操作人'
            }]
          }
        }
      }, (err) => { });
    },
    docotrChange1(val) {
      this.arrList4 = val
      this.projectDoctor.forEach(item => {
        if (item.doctorId == val) {
          this.listName2 = item.doctorName
        }
      });

    },
    // 复制时部位值改变事件
    editPositionChange(val, idx) {
      this.offFirstEnter = false
      this.editEppointmentPosition[idx].positionId = val
      this.editPositionOptions.forEach(ele => {
        if (val == ele.positionId) {
          this.editEppointmentPosition[idx].positionName = ele.positionName
        }
      });

      if (this.arrList3.length != 0) {
        console.log('改变仪器值')
        this.instrumentNum = this.arrList3
      } else if (this.arrList3.length == 0) {
        console.log('没有改变仪器值')
        this.instrumentNum = this.formTableLIst.instrumentId
      }
      api.request("/instrument/findInstrumentById", {
        instrumentId: this.instrumentNum
      }, (res) => {
        this.$nextTick(() => {
          this.editPositionOptions = res.data.InstrumentPosition
          this.editPositionOptions.map((x, i) => {
            this.editEppointmentPosition.map((s) => {
              if (x.positionId === s.positionId) {
                x.disabled = true
              }
            })
          })
          this.$forceUpdate()
        });
      }, (err) => { })
    },
    editPositionFocus(val, idx) {
      if (this.arrList3.length != 0) {
        console.log('改变仪器值')
        this.instrumentNum = this.arrList3
      } else if (this.arrList3.length == 0) {
        console.log('没有改变仪器值')
        this.instrumentNum = this.formTableLIst.instrumentId
      }
      api.request("/instrument/findInstrumentById", {
        instrumentId: this.instrumentNum
      }, (res) => {
        this.$nextTick(() => {
          this.editPositionOptions = res.data.InstrumentPosition
          this.editPositionOptions.map((x, i) => {
            this.editEppointmentPosition.map((s) => {
              if (x.positionId === s.positionId) {
                x.disabled = true
              }
            })
          })
          this.$forceUpdate()
        });
      }, (err) => { })
    },
    // 复制时删除部位
    editRemoveDomain(item, listIndex) {
      var index = this.editEppointmentPosition.indexOf(item)
      if (index !== -1) {
        this.editEppointmentPosition.splice(listIndex, 1)
      }
      this.offFirstEnter = false
    },
    // 复制时新增部位
    editAddDomain() {
      this.editEppointmentPosition.push({
        positionId: '',
        positionName: '',
        useTime: '',
        key: Date.now()
      });
      this.offFirstEnter = false
    },
    // 确定复制数据
    copySure() {
      if (!this.formTableLIst.doctorId || this.formTableLIst.doctorId == [] || this.formTableLIst.doctorId.length ==
        0) {
        _g.toast("warning", "请选择操作人")
        return;
      }
      let empId = Lockr.get("empId");
      let data = JSON.parse(JSON.stringify(this.formTableLIst))
      console.log('初始数据data')
      console.log(data)
      var dataList = {
        AppointmentProject: [{
          projectName: data.projectName,
          instrumentName: data.instrumentName,
          doctorName: data.doctorName,
          operationStatus: 3,
          projectInstrument: [{
            instrumentId: data.instrumentId
          }],
          projectDoctor: [{
            doctorId: data.doctorId
          }],
          remark: data.remark,
          appointmentPosition: this.editEppointmentPosition,
          id: data.projectId,
          appointStatus: data.appointStatus,
          projectId: data.projectId,
          areaCode: data.areaCode,
          floorCode: data.floorCode,
        }],
        customerName: data.customerName,
        mobile: data.mobile,
        appointmentTime: data.appointmentTime,
        userId: empId,
        projectType: data.projectType,
        cadCode: data.cadCode
      }
      this.areaOptions.forEach(ele => {
        if (data.areaCode == ele.areaCode) {
          dataList.areaName = ele.areaName
        }
      });
      this.floorOptions.forEach(ele => {
        if (data.floorCode == ele.floorCode) {
          dataList.floorName = ele.floorName
        }
      });
      if (this.listName2) {
        dataList.AppointmentProject[0].doctorName = this.listName2
      }
      if (this.listName1) {
        dataList.AppointmentProject[0].instrumentName = this.listName1
      }
      if (this.arrList3.length != 0) {
        dataList.AppointmentProject[0].projectInstrument[0].instrumentId = this.arrList3
      }
      if (this.arrList4.length != 0) {
        dataList.AppointmentProject[0].projectDoctor[0].doctorId = this.arrList4
      }
      if (this.copyProjectName) {
        dataList.AppointmentProject[0].projectName = this.copyProjectName
      }
      dataList.areaType = this.areaType
      dataList.areaCode = this.areaType
      console.log('最后提交的数据dataList')
      console.log(dataList)
      var that = this
      let sureData = {
        mobile: this.formTableLIst.mobile,
        customerName: this.formTableLIst.customerName,
        projectId: this.formTableLIst.projectId, // 项目id集合
        appointmentId: '', // 修改时必传
        status: 1, // 1：新增 2：修改
        appointmentTime: this.formTableLIst.appointmentTime.split(' ')[0]
      }
      // console.log(this.dataParam)
      api.requestQuiet("/appointment/findDistinguishData", sureData, (res) => {
        if (res.data != 0) {
          this.$confirm("该客户在当前时间已预约过此项目,是否确定要重复预约？", {
            center: true,
          }).then((res) => {
            that.insertList(dataList)
          }).catch((err) => {
            // this.$message.error('删除失败！');
          });
        } else if (res.data == 0) {
          that.insertList(dataList)
        }
      }, (err) => { });
    },
    // 新增项目接口封装
    insertList(dataList) {
      api.requestQuiet("/appointment/insertOrUpdateAppointment", dataList, (res) => {
        if (res.result == true) {
          this.copyDialogForm = false;
          if (res.data != '') {
            _g.toast("success", res.data);
          }
          this.$emit('add-comment')
        } else {
          _g.toast("error", res.errMsg);
        }
      }, (err) => { });
    },
  }
}
</script>
<style scoped>
@import "../../assets/css/main.css";

.dialogItem>>>.el-input__inner {
  height: 34px;
  background: #ffffff;
  /* box-shadow: 0px 0px 5px 3px #caeafd; */
  border-radius: 3px;
  /* border: 1px solid #23a2ee; */
}

.dialogItem>>>.el-form-item__label {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #626365;
  width: 96px;
}

.partFooter>>>.el-button--primary {
  width: 125px;
  height: 34px;
  background: #5a7ef8;
  border-radius: 17px;
  line-height: 5px;
}

.checkButton>>>.el-button--primary {
  width: 98px;
  height: 34px;
  background: #5a7ef8;
  border-radius: 17px;
  line-height: 5px;
}

.partFooter>>>.el-button--danger {
  width: 125px;
  height: 34px;
  border-radius: 17px;
  border: 1px solid #5a7ef8;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #5a7ef8;
  line-height: 2px;
  background: none;
}

.pageInput>>>.el-input__inner {
  width: 400px;
  height: 38px;
  background: #f6f7fb;
  border-radius: 23px;
  border: none;
}

.pageInput>>>.el-button {
  height: 34px;
  border-radius: 17px;
  border: 1px solid #979797;
  line-height: 5px;
  margin-left: 8px;
}

.appointTimeLong {
  text-align: left;
  margin-left: 5%;
  width: 400px;
}

.appointTimeLong>>>.el-tag {
  margin-bottom: 10px;
  margin-right: 10px;
}

.instrucPosition>>>.el-button i {
  margin: 0 !important;
}

.dialogItem>>>.el-form-item__error {
  left: 30px !important;
}

.tips>>>.el-input__inner {
  background-color: #ecf5ff;
  border-color: #d9ecff;
  color: #409eff;
  width: 155px;
}

.tooltips>>>.el-input__inner {
  background-color: #fef0f0;
  border-color: #fde2e2;
  color: #f56c6c;
  width: 155px;
}

.tips>>>.el-icon-arrow-up:before {
  color: #409eff;
}

.tooltips>>>.el-icon-arrow-up:before {
  color: #f56c6c;
}
</style>